module.exports = __webpack_public_path__ + "static/media/Exhibition-1@2x.369c5000.png";